import {Trans, useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import WebSchedulingHeading from "@components/Booking/Heading";
import React from "react";

const HeadingWithReason = ({apptReason}: {apptReason: string}) => {
  const i18nDB = useTranslation(I18nNamespace.DB);
  const translatedApptReasonName = i18nDB.t(apptReason, {
    ns: "website-db",
  });

  return (
    <WebSchedulingHeading>
      <Trans ns="web-scheduling">
        Select a location
        <br />
        <span className="lowercase">
          <>for {{translatedApptReasonName}}</>
        </span>
      </Trans>
    </WebSchedulingHeading>
  );
};
export default React.memo(HeadingWithReason);
